import React from 'react';
import { Link } from 'react-router-dom';
import ScrollReveal from './ScrollReveal';
import { useLanguage } from '../i18n/LanguageContext';

export default function DetailPage({ type, id }) {
  const { t, lang } = useLanguage();
  const isProduct = type === 'product';

  const section = isProduct ? t.products : t.services;
  const base = section.items.find(item => item.id === id);
  const extra = (isProduct ? t.productPages : t.servicePages)[id];

  const backTo = isProduct ? '/#products' : '/#services';
  const backLabel = isProduct ? t.detail.productsLabel : t.detail.servicesLabel;
  const backArrow = lang === 'ar' ? '→' : '←';

  return (
    <section className="page-section detail-page">
      <div className="container">
        <ScrollReveal className="section-head center">
          <span className="section-eyebrow">{section.eyebrow}</span>
          <div className="accent-line center" />
          <h1 className="section-title">{base.title}</h1>
          <p className="section-sub center">{base.desc}</p>
          {base.tags && (
            <div className="prod-tags center">
              {base.tags.map(tag => <span key={tag} className="prod-tag">{tag}</span>)}
            </div>
          )}
        </ScrollReveal>

        {extra.overview && (
          <ScrollReveal className="detail-overview-wrap">
            <p className="detail-overview">{extra.overview}</p>
          </ScrollReveal>
        )}

        {extra.highlights?.length > 0 && (
          <>
            <ScrollReveal className="detail-subhead">
              <h2 className="detail-subtitle">{t.detail.whatsIncluded}</h2>
            </ScrollReveal>
            <div className="detail-highlights-grid">
              {extra.highlights.map((h, i) => (
                <ScrollReveal key={h.title} delay={i * 60}>
                  <div className="detail-highlight-card">
                    <h3>{h.title}</h3>
                    <p>{h.desc}</p>
                  </div>
                </ScrollReveal>
              ))}
            </div>
          </>
        )}

        {extra.benefits?.length > 0 && (
          <>
            <ScrollReveal className="detail-subhead">
              <h2 className="detail-subtitle">{t.detail.keyBenefits}</h2>
            </ScrollReveal>
            <div className="detail-benefits-grid">
              {extra.benefits.map((b, i) => (
                <ScrollReveal key={b} delay={i * 50}>
                  <div className="detail-benefit-item">
                    <span className="detail-benefit-check">✓</span>
                    <span>{b}</span>
                  </div>
                </ScrollReveal>
              ))}
            </div>
          </>
        )}

        {extra.idealFor?.length > 0 && (
          <ScrollReveal className="detail-idealfor">
            <h2 className="detail-subtitle center">{t.detail.idealFor}</h2>
            <div className="detail-idealfor-chips">
              {extra.idealFor.map(f => <span key={f} className="detail-idealfor-chip">{f}</span>)}
            </div>
          </ScrollReveal>
        )}

        <ScrollReveal className="detail-actions center">
          <Link to={backTo} className="detail-back-btn">{backArrow} {t.detail.backTo} {backLabel}</Link>
          <Link to="/contact" className="btn-primary">{t.detail.getQuote}</Link>
        </ScrollReveal>
      </div>
    </section>
  );
}
